<ion-card class="missing-box">
  <ion-card-header class="ion-text-center">
    <ion-card-title>
      Application not found.
      <ion-icon name="alert" color="danger" size="small"></ion-icon>
    </ion-card-title>
    <ion-card-subtitle>
      Hmm, we're sorry but this application is missing.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <ion-card-content>
      <ion-img class="missing-img" src="assets/svg/missing.svg"></ion-img>
    </ion-card-content>
  </ion-card-content>
  <ion-card-content>
    <ion-button class="ion-text-wrap call-to-action-btn" type="button" expand="block" fill="clear" size="large"
      (click)="search()">Search
      programs and
      create a new
      application</ion-button>
  </ion-card-content>
</ion-card>